import { FC } from 'react';

import DestructiveActionModal from '@/shared/components/modals/DestructiveActionModal';

interface DeletePrimitiveModalProps {
    onCancel: () => void;
    onDelete: () => Promise<void>;
    open: boolean;
    resourceLabel: string;
    resourceName: string;
    warning?: string;
}

/** Applies the platform's permanent-deletion contract to developer and workspace primitives. */
const DeletePrimitiveModal: FC<DeletePrimitiveModalProps> = ({
    onCancel,
    onDelete,
    open,
    resourceLabel,
    resourceName,
    warning,
}) => (
    <DestructiveActionModal
        actionLabel={`Delete ${resourceLabel}`}
        alertDescription={
            warning ??
            `Deleting this ${resourceLabel.toLowerCase()} immediately revokes its access and cannot be undone.`
        }
        confirmationValue={resourceName}
        errorMessage={`Unable to delete ${resourceLabel.toLowerCase()}`}
        onCancel={onCancel}
        onConfirm={onDelete}
        open={open}
        title={`Delete ${resourceLabel}`}
    />
);

export default DeletePrimitiveModal;
